import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const footerCols = [
    {
        title: "Company",
        links: [
            { to: "/about", label: "About" },
            { to: "/how-it-works", label: "How it works" },
            { to: "/carriers", label: "Carriers" },
            { to: "/join", label: "Join the team" },
        ],
    },
    {
        title: "Coverage",
        links: [
            { to: "/coverage/term-life", label: "Term Life" },
            { to: "/coverage/whole-life", label: "Whole Life" },
            { to: "/coverage/iul", label: "IUL" },
            { to: "/coverage/final-expense", label: "Final Expense" },
            { to: "/coverage/annuities", label: "Annuities" },
            { to: "/coverage/medicare", label: "Medicare" },
            { to: "/coverage/dental-vision", label: "Dental & Vision" },
        ],
    },
    {
        title: "Resources",
        links: [
            { to: "/blog", label: "Blog" },
            { to: "/jarvis", label: "Meet Jarvis" },
            { to: "/faq", label: "FAQ" },
            { to: "/book", label: "Book a call" },
            { to: "/contact", label: "Contact" },
        ],
    },
    {
        title: "Legal",
        links: [
            { to: "/privacy", label: "Privacy" },
            { to: "/terms", label: "Terms" },
            { to: "/login", label: "Admin" },
        ],
    },
];

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-mm-navy text-white" data-testid="site-footer">
            <div className="mm-container py-12 sm:py-20">
                <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-10 md:grid-cols-5">
                    <div className="space-y-4 sm:col-span-2 md:col-span-1">
                        <BrandLogo size={32} wordmarkTone="light" />
                        <p className="max-w-xs text-sm text-white/70 leading-relaxed">
                            Independent insurance advisors. Human guidance, AI-assisted. No pressure. No guesswork.
                        </p>
                    </div>
                    {footerCols.map((col) => (
                        <div key={col.title} data-testid={`footer-col-${col.title.toLowerCase()}`}>
                            <div className="mb-4 text-[0.72rem] uppercase tracking-[0.22em] text-white/60">
                                {col.title}
                            </div>
                            <ul className="space-y-2.5 text-sm">
                                {col.links.map((l) => (
                                    <li key={l.to}>
                                        <Link
                                            to={l.to}
                                            className="text-white/85 transition-colors hover:text-mm-sky"
                                        >
                                            {l.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-14 border-t border-white/10 pt-8">
                    <p
                        className="mx-auto max-w-4xl text-center text-[0.78rem] leading-relaxed text-white/60"
                        data-testid="footer-disclaimer"
                    >
                        Moving Mountains Advisors does not guarantee approval, rates, or
                        outcomes. We do not sell your data. This experience is
                        powered by advanced AI technology; a licensed advisor
                        reviews every recommendation.
                    </p>
                    <p className="mt-6 text-center text-xs text-white/50">
                        © {year} Moving Mountains Advisors. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
